import { Component, Input, Output, EventEmitter, ElementRef, OnInit } from '@angular/core';

export interface ContextMenuOption {
	item?: any;
	label?: string;
	value?: string;
	icon?: string;
	iconText?: string;
	data?: any;
	onSelected?: (option: ContextMenuOption, ev: MouseEvent) => any;
}

@Component({
	selector: 'bb-context-menu',
	templateUrl: './bb-context-menu.component.html',
	styleUrls: ['./bb-context-menu.component.scss']
})

export class BbContextMenuComponent implements OnInit {
	@Input() options: any;
	@Input() themeName: string;
	@Output() optionSelected: EventEmitter<ContextMenuOption> = new EventEmitter<ContextMenuOption>();

	constructor(private elementRef: ElementRef) { }

	ngOnInit() { }

	onOptionSelected(option: ContextMenuOption, ev: MouseEvent) {
		ev.preventDefault();
		ev.stopPropagation();
		if (option && typeof option.onSelected === 'function') {
			option.onSelected(option, ev);
		}
		this.optionSelected.emit(option);

		// implement this later with a contextmenu directive:
		// this.hideContextMenu();
	}

	hideContextMenu() {
		this.elementRef.nativeElement.style.display = 'none';
	}
}
